module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/timeline-bullet-3508e315fe0bfb95a5acbe99c03db72c.svg";